//= require bijou/cjs_shim
//= require jquery/dist/jquery
//= require bijou/jquery-ui

require('jquery')
require('../../../../vendor/assets/javascripts/bijou/jquery-ui')

;(function ($) {
  'use strict'

  var Breakpoint = (function () {
    var currentLabel
    var inited = false

    function init () {
      if (!inited) {
        currentLabel = readLabel()

        $(window).on('resize orientationchange', function () {
          var label = readLabel()

          if (currentLabel !== label) {
            $(this).triggerHandler('breakpointchange', {
              oldLabel: currentLabel,
              newLabel: label
            })
            currentLabel = label
          }
        })

        inited = true
      }
    }

    function readLabel () {
      var label = window.getComputedStyle && window.getComputedStyle(document.body, '::before')
      label = label && ((label.content !== 'none' && label.content) || false)
      return (label && label.replace(/('|"|\s+)/g, ''))
    }

    return {
      label: function () {
        return currentLabel
      },

      attach: function (widget) {
        init()

        $(window).on('breakpointchange', function (e, labels) {
          $(widget.element).triggerHandler('breakpointchange' + widget.eventNamespace, labels)
        })

        return this
      }
    }
  }())

  $.widget('bijou.base', {
    options: {
      defaultBreakpoint: 'desktop'
    },

    _getCreateOptions: function () {
      var key
      var opts = {}
      var data = this.element.data()
      var validTypes = ['string', 'number', 'boolean']

      for (key in data) {
        if (data.hasOwnProperty(key) && $.inArray(typeof data[key], validTypes) > -1) {
          opts[key] = data[key]
        }
      }

      return opts
    },

    disable: function () {
      this._super()

      // Remove disabled ARIA attribute and class.
      // We want the widget to be disabled, not the HTML element itself.
      this.widget()
        .removeAttr('aria-disabled')
        .removeClass('ui-state-disabled')
    },

    enable: function () {
      this._super()

      // Remove ARIA disabled attribute as it isn't needed (jQuery UI sets it to true)
      this.widget().removeAttr('aria-disabled')
    },

    // Breakpoint helper methods

    breakpointEnabled: function () {
      var _this = this

      this.options.breakpoint = Breakpoint.attach(this).label() || this.options.defaultBreakpoint

      this.breakpointTriggers = {
        enter: {},
        leave: {}
      }

      this._on(true, {
        'breakpointchange': function (e, data) {
          this.options.breakpoint = data.newLabel

          this._breakpointCallbacks(data.newLabel, 'enter').each(function (_, callback) {
            callback()
          })

          this._breakpointCallbacks(data.oldLabel, 'leave').each(function (_, callback) {
            callback()
          })
        }
      })

      if (this.options.disableOnBreakpoint) {
        this._onBreakpoint(this.options.disableOnBreakpoint, function () {
          _this.disable()
        }, function () {
          _this.enable()
        })

        if (this.options.breakpoint === this.options.disableOnBreakpoint) {
          this.disable()
        }
      }

      if (this.options.enableOnBreakpoint) {
        this._onBreakpoint(this.options.enableOnBreakpoint, function () {
          _this.enable()
        }, function () {
          _this.disable()
        })

        if (this.options.breakpoint !== this.options.enableOnBreakpoint) {
          this.disable()
        }
      }
    },

    _breakpointCallbacks: function (label, dir) {
      return this.breakpointTriggers[dir][label] || (this.breakpointTriggers[dir][label] = $([]))
    },

    _onBreakpoint: function (label, enterCallback, leaveCallback) {
      if (enterCallback) {
        this._breakpointCallbacks(label, 'enter').push(enterCallback)
      }

      if (leaveCallback) {
        if (leaveCallback === true) {
          this._breakpointCallbacks(label, 'leave').push(enterCallback)
        } else {
          this._breakpointCallbacks(label, 'leave').push(leaveCallback)
        }
      }
    },

    _onEnterBreakpoint: function (label, callback) {
      this._onBreakpoint(label, callback)
    },

    _onLeaveBreakpoint: function (label, callback) {
      this._onBreakpoint(label, null, callback)
    }
  })
}(window.jQuery))
